import React from 'react'
import { inject, observer } from 'mobx-react'

import { dateCell } from '../../components/columns'

import { CreateButton, ReloadButton } from '../../components/buttons'
import { DeleteButton } from '../../components/delete'

import { DataTable } from '../../components/DataTable'


const columns = (postalStore) => [{
  Header: <span>
    <ReloadButton title="postals.reload" onClick={postalStore.reload} />
  </span>,
  accessor: 'id',
  headerClassName: 'centered sb-actions',
  className: 'centered sb-actions',
  width: 30,
  sortable: false,
  resizable: false,
  Cell : cell => (
    <span>
      <DeleteButton title="postal.delete" onClick={postalStore.remove(cell.original)}/>
    </span>
  )
},{
  Header: 'Name',
  accessor: 'name',
  headerClassName: 'left',
  //Cell : textEdit(customerStore.update),
},{
  Header: 'Angelegt',
  accessor: 'created',
  className: 'centered',
  width: 80,
  resizable: false,
  Cell : dateCell,
},{
  Header: <span>
      <CreateButton title="postal.create" onClick={postalStore.create()} />
  </span>,
  accessor: 'id',
  headerClassName: 'centered sb-actions',
  className: 'centered',
  width: 30,
  sortable: false,
  resizable: false,
  // Cell : cell => (
  //   <span>
  //     <CreateButton title="einen neuen Auftrag anlegen" onClick={contractsStore.create} />
  //   </span>
  // )
}]

@inject('postalStore')
@observer
export class PostalsList extends React.Component {
  render() {
    return <DataTable store={this.props.postalStore} columns={columns(this.props.postalStore)}
      sortable={false}
      defaultSorted={[{
        id : 'name',
      }]}
    />
  }
}
